export const CHECKOUT = 'CHECKOUT';
export const CHECKOUT_CART = 'CHECKOUT_CART';
export const CHECKOUT_CART_LOADING = 'CHECKOUT_CART_LOADING';
export const CHECKOUT_TOTALS = 'CHECKOUT_TOTALS';
export const CHECKOUT_TOTALS_LOADING = 'CHECKOUT_TOTALS_LOADING';
export const CHECKOUT_CART_ADD_ITEM = 'CHECKOUT_CART_ADD_ITEM';
export const CHECKOUT_CART_DELETE_ITEM = 'CHECKOUT_CART_DELETE_ITEM';
export const CHECKOUT_CART_UPDATE_ITEM = 'CHECKOUT_CART_UPDATE_ITEM';
export const CHECKOUT_CART_CLEAR_CART = 'CHECKOUT_CART_CLEAR_CART';
export const CHECKOUT_SHIPPING_ADDRESS = 'CHECKOUT_SHIPPING_ADDRESS';
export const CHECKOUT_SHIPPING_METHODS = 'CHECKOUT_SHIPPING_METHODS';
export const CHECKOUT_PAYMENT_METHODS = 'CHECKOUT_PAYMENT_METHODS';
